import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { Observable } from 'rxjs';

export interface IDecisionMaker {
  decision_maker_email: string,
  decision_maker_name: string,
  decision_maker_role: string,
  tenant_id: string,
  is_frontegg_user: boolean,
  count_24h: number,
  count_7d: number,
  count_30d: number
}

@Injectable({
  providedIn: 'root'
})
export class DecisionMakerService {
  http = inject(HttpClient);

  getDecisionMakers(): Observable<IDecisionMaker[]> {
    return this.http.get<IDecisionMaker[]>(`${environment.yomaApiURL}/decision_makers`)
  }
}
